import { render, staticRenderFns } from "./AdministrativeDetail.vue?vue&type=template&id=4618979c&scoped=true&lang=pug&"
import script from "./AdministrativeDetail.vue?vue&type=script&lang=js&"
export * from "./AdministrativeDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeDetail.vue?vue&type=style&index=0&id=4618979c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618979c",
  null
  
)

export default component.exports